import { createReducer } from 'deox';
import produce from 'immer';
import { convertToImgix } from 'src/utils/transformers';
import { resetImagesArr, setImagesArr, setLng, setLocation } from './actions';
import { appState } from './types';

export const appInitialState: appState = {
  location: '',
  lng: 'am',
  imagesArr: [],
  cities: ['Sharm El Sheikh', 'Hurghada', 'Cairo', 'Aswan'],
  languages: ['en', 'ru', 'am'],
};

export const appReducer = createReducer(appInitialState, (handle) => [
  handle(setImagesArr, (state, { payload }: any) =>
    produce(state, (draft) => {
      draft.imagesArr = payload.map((url: string) => convertToImgix(url));
    })
  ),
  handle(resetImagesArr, (state) =>
    produce(state, (draft) => {
      draft.imagesArr = [];
    })
  ),
  handle(setLng, (state, { payload }: any) =>
    produce(state, (draft) => {
      draft.lng = payload;
    })
  ),
  handle(setLocation, (state, { payload }: any) =>
    produce(state, (draft) => {
      draft.location = payload;
    })
  ),
]);
